import { withProps } from 'recompose'
import { Provider } from 'react-redux'
import store from 'src/store'

export default withProps(() => ({
  store
}))(Provider)
